import { Phone, Mail, Facebook, MapPin, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { COMPANY } from "../data";

export const Footer = ({ onQuote }) => (
  <footer id="contact" data-testid="footer" className="relative border-t border-white/10 bg-[#0c0c10]">
    {/* CTA band */}
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 sm:py-20 text-center">
      <span className="font-mono-sx text-xs uppercase tracking-[0.25em] text-[#f5641e]">Get in touch today</span>
      <h2 className="mt-4 font-display text-3xl sm:text-5xl font-extrabold uppercase tracking-tight">
        Keep your home <span className="flame-text">warm</span>
      </h2>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
        <button onClick={onQuote} data-testid="footer-quote-btn" className="rounded-full bg-[#f5641e] px-8 py-4 font-bold text-[#0a0a0c] hover:bg-[#ff7a38] transition-colors">
          Get a Free Quote
        </button>
        <a href={`tel:${COMPANY.phoneIntl}`} data-testid="footer-call-btn" className="inline-flex items-center gap-2 rounded-full border border-white/15 px-8 py-4 font-bold text-white hover:border-[#f5641e]/60 transition-colors">
          <Phone className="h-4 w-4 text-[#f5641e]" /> {COMPANY.phone}
        </a>
      </div>
    </div>

    <div className="hairline">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-12 grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Logo />
          <p className="mt-5 max-w-xs text-sm text-zinc-400 leading-relaxed">
            Your local heating & plumbing experts. Reliable, professional and local —
            keeping Essex homes warm, comfortable and running smoothly.
          </p>
          <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-[#FFD700]/30 bg-[#FFD700]/10 px-4 py-2">
            <span className="font-mono-sx text-[10px] uppercase tracking-widest text-[#FFD700]">Gas Safe Registered</span>
          </div>
        </div>

        <div>
          <h4 className="font-mono-sx text-[10px] uppercase tracking-widest text-zinc-500">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li><a href={`tel:${COMPANY.phoneIntl}`} className="flex items-center gap-2 text-zinc-300 hover:text-white"><Phone className="h-4 w-4 text-[#f5641e]" /> {COMPANY.phone}</a></li>
            <li><a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 text-zinc-300 hover:text-white"><Mail className="h-4 w-4 text-[#f5641e]" /> {COMPANY.email}</a></li>
            <li><a href={COMPANY.facebook} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-zinc-300 hover:text-white"><Facebook className="h-4 w-4 text-[#f5641e]" /> SX Heating LTD <ArrowUpRight className="h-3 w-3" /></a></li>
            <li className="flex items-center gap-2 text-zinc-300"><MapPin className="h-4 w-4 text-[#f5641e]" /> {COMPANY.area}</li>
          </ul>
        </div>

        <div>
          <h4 className="font-mono-sx text-[10px] uppercase tracking-widest text-zinc-500">Services</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-zinc-300">
            {["Boiler Swaps", "System Conversions", "Bathrooms", "Boiler Break Downs", "Boiler Services"].map((s) => (
              <li key={s}><a href="#services" className="hover:text-white transition-colors">{s}</a></li>
            ))}
          </ul>
        </div>
      </div>
    </div>

    <div className="hairline">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono-sx text-[11px] uppercase tracking-widest text-zinc-600">
          © {new Date().getFullYear()} SX Heating Ltd · Company No. {COMPANY.companyNumber}
        </p>
        <p className="font-mono-sx text-[11px] uppercase tracking-widest text-zinc-600">
          Quality Work. Every Time.
        </p>
      </div>
    </div>
  </footer>
);
